import { TableContainer, Typography } from "@mui/material"
import styles from "../Utils/table.module.css"

const GenerateNestedColumns = (columns, path = []) => {

    return columns?.map((col, colIndex) => {
        if (col?.type === "nested") {
            return (
                <th style={{ padding: '0px' }}>
                    <table
                        className={`${styles?.table} ${styles?.['nested-table']}`}
                    >
                        <thead>
                            <tr>
                                <th
                                    colSpan={(col?.value?.length || 0) + 1}
                                    style={{ textAlign: "center" }}
                                >
                                    {col?.uniqueName}
                                </th>
                            </tr>
                            <tr>
                                {GenerateNestedColumns(
                                    col?.value ?? [],
                                    [...path, col?.uniqueName],
                                )}
                            </tr>
                        </thead>
                    </table>
                </th>
            );
        } else {
            return (
                <th
                    style={{
                        textAlign: "center",
                        minWidth: '300px',
                        maxWidth: '300px',
                        overflowY: 'hidden',
                        overflowX: 'auto'
                    }}
                >
                    {col?.name ?? "-"}
                </th>
            );
        }
    });
};

const renderStaticRow = (
    columns,
) => {
    return columns.map((column, idx) => {

        if (column.type === "nested") {
            const nestedRows = [{}];

            return (
                <td style={{ padding : '0px'}}>
                    <table className={`${styles?.table} ${styles?.['nested-table']}`}>
                        <tbody style={{ padding: "0px" }}>
                            {nestedRows.length > 0 ? (
                                nestedRows.map((nestedRow, i) => (
                                    <tr>
                                        {renderStaticRow(column.value)}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={column.value.length}>
                                        <Typography variant="body2" color="text.secondary">
                                            No data
                                        </Typography>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </td>
            );
        } else {
            return (
                <td
                    style={{
                        textAlign: "center",
                        minWidth: '300px',
                        maxWidth: '300px',
                        overflowY: 'hidden',
                        overflowX: 'auto'
                    }}
                >
                </td>
            );
        }
    });
};

const HTML_NestedTable = (props) => {
    const { columns = [], config = {} } = props

    return (

        <TableContainer
            sx={{
                scrollbarWidth: "thin",
                scrollbarColor: "#0000FF #00000000",
                pb: 1
            }}
        >
            <table
                className={`${styles?.table} ${styles?.['nested-table']}`}
                style={{
                    borderCollapse: "collapse",
                    width: "100%",
                }}
            >
                <thead>
                    <tr>
                        {GenerateNestedColumns(
                            columns,
                        )}
                    </tr>
                </thead>
                <tbody>
                    {
                        Array.from({ length: 1 })?.map((r, ri) => {
                            return (
                                <tr>
                                    {renderStaticRow(columns)}
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </TableContainer>
    )
}

export default HTML_NestedTable
